import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.fun';
  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Kakobuy Finds Polska",
    "url": siteUrl,
    "description": "Największa baza Kakobuy Spreadsheet dla użytkowników z Polski.",
    "inLanguage": "pl-PL",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <script type="application/ld+json">
          {JSON.stringify(webSiteSchema)}
        </script>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
